import { icons } from "../icons";

export const skills = [
  { icon: icons.html, title: "html" },
  { icon: icons.css, title: "css" },
  { icon: icons.javascript, title: "javascript" },
  { icon: icons.dart, title: "dart" },
  { icon: icons.python, title: "python" },
  { icon: icons.react, title: "react" },
  { icon: icons.flutter, title: "flutter" },
  { icon: icons.node, title: "node" },
];
